<template>
  <div>
    <v-container fluid>
      <v-form ref="lab_result_form">
        <v-row>
          <v-col cols="12" class="pt-5 pb-1">
            <span style="color: #00a99d; font-size: 20px; font-weight: bold">
              ผลตรวจทางห้องปฏิบัติการ
            </span>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="list"
              hide-default-footer
              no-data-text="ไม่มีข้อมูล"
              class="my-table"
              style="background-color: #fcfcfc"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <!-- LiverFunction -->
                  <tr style="background-color: #f2fcf5">
                    <td><span style="color: #00a99d">การทำงานของตับ</span></td>
                    <td></td>
                    <td></td>
                    <td style="text-align: right">
                      <v-btn icon @click="toggleExpand1()">
                        <v-icon color="#00a99d">{{
                          toggle1 != false
                            ? "mdi-chevron-up"
                            : "mdi-chevron-down"
                        }}</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <!-- totalProtein -->
                  <tr
                    v-for="item in items[0].liver[0].totalProtein"
                    :key="item.id"
                    v-show="toggle1 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.totalProtein.result"
                        @input="
                          cal_reuslt_maxmin(
                            'totalProtein',
                            LiverFunction.totalProtein.result,
                            8.3,
                            6.4
                          )
                        "
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td style="text-align: center">{{ item.normal }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.totalProtein.summary"
                        outlined
                        dense
                        readonly
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>
                  <!-- albumin -->
                  <tr
                    v-for="item in items[0].liver[1].albumin"
                    :key="item.id"
                    v-show="toggle1 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.albumin.result"
                        @input="
                          cal_reuslt_maxmin(
                            'albumin',
                            LiverFunction.albumin.result,
                            5.2,
                            3.5
                          )
                        "
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td style="text-align: center">{{ item.normal }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.albumin.summary"
                        outlined
                        dense
                        readonly
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>
                  <!-- totalBilirubin -->
                  <tr
                    v-for="item in items[0].liver[3].totalBilirubin"
                    :key="item.id"
                    v-show="toggle1 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.totalBilirubin.result"
                        @input="
                          cal_reuslt_maxmin(
                            'totalBilirubin',
                            LiverFunction.totalBilirubin.result,
                            1.1,
                            0.2
                          )
                        "
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td style="text-align: center">{{ item.normal }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.totalBilirubin.summary"
                        outlined
                        dense
                        readonly
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>
                  <!-- directBilirubin -->
                  <tr
                    v-for="item in items[0].liver[4].directBilirubin"
                    :key="item.id"
                    v-show="toggle1 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.directBilirubin.result"
                        @input="
                          cal_reuslt_max(
                            'directBilirubin',
                            LiverFunction.directBilirubin.result,
                            0.5
                          )
                        "
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td style="text-align: center">{{ item.normal }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.directBilirubin.summary"
                        outlined
                        dense
                        readonly
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>
                  <!-- sgot -->
                  <tr
                    v-for="item in items[0].liver[6].sgot"
                    :key="item.id"
                    v-show="toggle1 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.sgot.result"
                        @input="
                          cal_reuslt_max_gender(
                            'sgot',
                            LiverFunction.sgot.result,
                            60,
                            35
                          )
                        "
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td style="text-align: center">
                      <div v-html="item.normal"></div>
                    </td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.sgot.summary"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>
                  <!-- sgpt -->
                  <tr
                    v-for="item in items[0].liver[7].sgpt"
                    :key="item.id"
                    v-show="toggle1 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.sgpt.result"
                        @input="
                          cal_reuslt_max_gender(
                            'sgpt',
                            LiverFunction.sgpt.result,
                            50,
                            35
                          )
                        "
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td style="text-align: center">
                      <div v-html="item.normal"></div>
                    </td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.sgpt.summary"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>
                  <!-- alkPhosphatase -->
                  <tr
                    v-for="item in items[0].liver[8].alkPhosphatase"
                    :key="item.id"
                    v-show="toggle1 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.alkPhosphatase.result"
                        @input="
                          cal_reuslt_maxmin(
                            'alkPhosphatase',
                            LiverFunction.alkPhosphatase.result,
                            120,
                            30
                          )
                        "
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td style="text-align: center">{{ item.normal }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="LiverFunction.alkPhosphatase.summary"
                        outlined
                        dense
                        readonly
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>

                  <!-- KidneyFunction -->
                  <tr style="background-color: #f2fcf5">
                    <td><span style="color: #00a99d">การทำงานของไต</span></td>
                    <td></td>
                    <td></td>
                    <td style="text-align: right">
                      <v-btn icon @click="toggleExpand2()">
                        <v-icon color="#00a99d">{{
                          toggle2 != false
                            ? "mdi-chevron-up"
                            : "mdi-chevron-down"
                        }}</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr
                    v-for="item in items[1].kidney[0].bun"
                    :key="item.id"
                    v-show="toggle2 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="KidneyFunction.bun.result"
                        @input="
                          cal_reuslt_maxmin(
                            'bun',
                            KidneyFunction.bun.result,
                            20,
                            8
                          )
                        "
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td style="text-align: center">{{ item.normal }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="KidneyFunction.bun.summary"
                        outlined
                        dense
                        readonly
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr
                    v-for="item in items[1].kidney[1].creatinine"
                    :key="item.id"
                    v-show="toggle2 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="KidneyFunction.creatinine.result"
                        @input="
                          cal_reuslt_maxmin(
                            'creatinine',
                            KidneyFunction.creatinine.result,
                            1.18,
                            0.55
                          )
                        "
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td style="text-align: center">{{ item.normal }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="KidneyFunction.creatinine.summary"
                        outlined
                        dense
                        readonly
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>

                  <!-- UricAcidFunction  -->
                  <tr style="background-color: #f2fcf5">
                    <td>
                      <span style="color: #00a99d"
                        >ตรวจระดับกรดยูริคในเลือด</span
                      >
                    </td>
                    <td></td>
                    <td></td>
                    <td style="text-align: right">
                      <v-btn icon @click="toggleExpand3()">
                        <v-icon color="#00a99d">{{
                          toggle3 != false
                            ? "mdi-chevron-up"
                            : "mdi-chevron-down"
                        }}</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr
                    v-for="item in items[2].uric[0].uricAcid"
                    :key="item.id"
                    v-show="toggle3 == false"
                  >
                    <td>
                      {{ item.name }}
                    </td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="UricAcidFunction.uricAcid.result"
                        @input="
                          calgender_reuslt(
                            'uricAcid',
                            UricAcidFunction.uricAcid.result,
                            {},
                            { M: 5, F: 8 },
                            '<',
                            item.gender
                          )
                        "
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td style="text-align: center">
                      <div
                        v-html="
                          'M 3.5-7.2 mg/dL <br> F 2.6 - 6.0 mg/L'
                        "
                      ></div>
                    </td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="UricAcidFunction.uricAcid.summary"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>

                  <!-- BloodGroupDetection  -->
                  <tr style="background-color: #f2fcf5">
                    <td><span style="color: #00a99d">ตรวจหาหมู่เลือด</span></td>
                    <td></td>
                    <td></td>
                    <td style="text-align: right">
                      <v-btn icon @click="toggleExpand4()">
                        <v-icon color="#00a99d">{{
                          toggle4 != false
                            ? "mdi-chevron-up"
                            : "mdi-chevron-down"
                        }}</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr
                    v-for="item in items[3].blood[0].bloodGroup"
                    :key="item.id"
                    v-show="toggle4 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="BloodGroupDetection.bloodGroup.result"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                    <td></td>
                    <td style="text-align: center"></td>
                  </tr>

                  <!-- HepatitisB  -->
                  <tr style="background-color: #f2fcf5">
                    <td>
                      <span style="color: #00a99d">ไวรัสตับอักเสบ</span>
                    </td>
                    <td></td>
                    <td></td>
                    <td style="text-align: right">
                      <v-btn icon @click="toggleExpand5()">
                        <v-icon color="#00a99d">{{
                          toggle5 != false
                            ? "mdi-chevron-up"
                            : "mdi-chevron-down"
                        }}</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr
                    v-for="item in items[4].hepB[0].HBsAg"
                    :key="item.id"
                    v-show="toggle5 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="HepatitisB.HBsAg.result"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td style="text-align: center">{{ item.normal }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="HepatitisB.HBsAg.summary"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr
                    v-for="item in items[4].hepB[1].antiHBs"
                    :key="item.id"
                    v-show="toggle5 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="HepatitisB.antiHBs.result"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td></td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="HepatitisB.antiHBs.summary"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>

                  <tr
                    v-for="item in items[4].hepB[2].antiHCV"
                    :key="item.id"
                    v-show="toggle5 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="hepatitisC.antiHCV.result"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td></td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="hepatitisC.antiHCV.summary"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>

                  <tr
                    v-for="item in items[4].hepB[3].HAV_IgM"
                    :key="item.id"
                    v-show="toggle5 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="hepatitisA.HAV_IgM.result"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td style="text-align: center">{{ item.normal }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="hepatitisA.HAV_IgM.summary"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>

                  <tr
                    v-for="item in items[4].hepB[4].antiHAV"
                    :key="item.id"
                    v-show="toggle5 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="hepatitisA.antiHAV.result"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td></td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="hepatitisA.antiHAV.summary"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>

                  <!-- Urine  -->
                  <tr style="background-color: #f2fcf5">
                    <td>
                      <span style="color: #00a99d">ตรวจหาสารเสพติด</span>
                    </td>
                    <td></td>
                    <td></td>
                    <td style="text-align: right">
                      <v-btn icon @click="toggleExpand6()">
                        <v-icon color="#00a99d">{{
                          toggle6 != false
                            ? "mdi-chevron-up"
                            : "mdi-chevron-down"
                        }}</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr
                    v-for="item in items[5].urine[0].amphetamine"
                    :key="item.id"
                    v-show="toggle6 == false"
                  >
                    <td>{{ item.name }}</td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="Urine.amphetamine.result"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลตรวจ"
                        class="custom-text-field"
                        color="#00a99d"
                        @keypress="validateNumber"
                        type="number"
                      ></v-text-field>
                    </td>
                    <td></td>
                    <td style="text-align: center">
                      <v-text-field
                        v-model="Urine.amphetamine.summary"
                        outlined
                        dense
                        hide-details="auto"
                        placeholder="ระบุผลการสรุป"
                        class="custom-text-field my-2"
                        color="#00a99d"
                      ></v-text-field>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { EventBus } from "../../EventBus";
import HealthCheckCal from "../../services/health_check_cal";
export default {
  props: {
    itemGender: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: "รายการตรวจ",
          value: "name",
          align: "center",
          sortable: false,
          width: "28%",
        },
        {
          text: "ผลตรวจ",
          value: "result",
          align: "center",
          sortable: false,
          width: "24%",
        },
        {
          text: "ค่าปกติ",
          value: "normal",
          sortable: false,
          align: "center",
          width: "24%",
        },
        {
          text: "สรุปผล",
          value: "summary",
          sortable: false,
          align: "center",
          width: "24%",
        },
      ],
      list: [
        {
          liver: [
            {
              totalProtein: [
                {
                  name: "Total Protein",
                  normal: "6.6-8.3 g/dL",
                },
              ],
            },
            {
              albumin: [
                {
                  name: "Albumin",
                  normal: "3.5-5.2 g/dL",
                },
              ],
            },
            {
              glubulin: [
                {
                  name: "Glubulin",
                  normal: "gm/dl (1.2 - 3.5)",
                },
              ],
            },
            {
              totalBilirubin: [
                {
                  name: "Total Bilirubin",
                  normal: "0.2 - 1.1 mg/dL",
                },
              ],
            },
            {
              directBilirubin: [
                {
                  name: "Direct Bilirubin",
                  normal: "<0.5 mg/dL",
                },
              ],
            },
            {
              indirectBilirubin: [
                {
                  name: "Indirect Bilirubin",
                  normal: "mg/dL (0 - 0.7)",
                },
              ],
            },
            {
              sgot: [
                {
                  name: "SGOT (AST)",
                  normal: "M < 60 U/L<br>F < 35 U/L",
                },
              ],
            },
            {
              sgpt: [
                {
                  name: "SGPT (ALT)",
                  normal: "M < 50 U/L<br>F < 35 U/L",
                },
              ],
            },
            {
              alkPhosphatase: [
                {
                  name: "Alk. Phosphatase",
                  normal: "30 - 120 U/L",
                },
              ],
            },
            {
              gammagt: [
                {
                  name: "Gamma GT",
                  normal: "U/L (9 - 64)",
                },
              ],
            },
          ],
        },
        {
          kidney: [
            {
              bun: [
                {
                  name: "BUN",
                  normal: "8 - 20 mg/dL",
                },
              ],
            },
            {
              creatinine: [
                {
                  name: "Creatinine",
                  normal: "0.55 - 1.18 mg/dL",
                },
              ],
            },
          ],
        },
        {
          uric: [
            {
              uricAcid: [
                {
                  name: "Uric Acid",
                  normal: "3.5-7.2 mg/dL",
                },
              ],
            },
          ],
        },
        {
          blood: [
            {
              bloodGroup: [
                {
                  name: "ABO",
                },
              ],
            },
            {
              bloodGroup_rh: [
                {
                  name: "Rh",
                },
              ],
            },
          ],
        },
        {
          hepB: [
            {
              HBsAg: [
                {
                  name: "HBs Ag (เชื้อไวรัสตับอักเสบบี)",
                  normal: "Negative",
                },
              ],
            },
            {
              antiHBs: [
                {
                  name: "Anti HBs (ภูมิคุ้มกันไวรัสตับอักเสบ บี)",
                },
              ],
            },
            {
              antiHCV: [
                {
                  name: "Anti HCV (ภูมิคุ้มกันไวรัสตับอักเสบ ซี)",
                },
              ],
            },
            {
              HAV_IgM: [
                {
                  name: "HAV IgM (เชื้อไวรัสตับอักเสบ เอ)",
                  normal: "Negative",
                },
              ],
            },
            {
              antiHAV: [
                {
                  name: "Anti HAV (ภูมิคุ้มกันไวรัสตับอักเสบ เอ)",
                },
              ],
            },
          ],
        },
        {
          urine: [
            {
              amphetamine: [
                {
                  name: "Amphetamine",
                },
              ],
            },
            {
              heroine: [
                {
                  name: "Heroine",
                },
              ],
            },
            {
              marijuana: [
                {
                  name: "Marijuana",
                },
              ],
            },
            {
              morphine: [
                {
                  name: "Morphine",
                },
              ],
            },
            {
              bloodalcohol: [
                {
                  name: "Blood Alcohol",
                },
              ],
            },
          ],
        },
      ],
      toggle1: false,
      toggle2: false,
      toggle3: false,
      toggle4: false,
      toggle5: false,
      toggle6: false,
      gender: "",
      LiverFunction: {
        totalProtein: {
          result: "",
          summary: "",
        },
        albumin: {
          result: "",
          summary: "",
        },
        glubulin: {
          result: "",
          summary: "",
        },
        totalBilirubin: {
          result: "",
          summary: "",
        },
        directBilirubin: {
          result: "",
          summary: "",
        },
        sgot: {
          result: "",
          summary: "",
        },
        sgpt: {
          result: "",
          summary: "",
        },
        alkPhosphatase: {
          result: "",
          summary: "",
        },
      },
      KidneyFunction: {
        bun: {
          result: "",
          summary: "",
        },
        creatinine: {
          result: "",
          summary: "",
        },
      },
      UricAcidFunction: {
        uricAcid: {
          result: "",
          summary: "",
        },
      },
      BloodGroupDetection: {
        bloodGroup: {
          result: "",
          summary: "",
          normal: "",
        },
        bloodGroup_RH: {
          result: "",
          summary: "",
          normal: "",
        },
      },
      HepatitisB: {
        HBsAg: {
          result: "",
          summary: "",
          normal: "",
        },
        antiHBs: {
          result: "",
          summary: "",
          normal: "",
        },
      },
      hepatitisA: {
        HAV_IgM: {
          result: "",
          summary: "",
        },
        antiHAV: {
          result: "",
          summary: "",
        },
      },
      hepatitisC: {
        antiHCV: {
          result: "",
          summary: "",
        },
      },
      Urine: {
        amphetamine: {
          result: "",
          summary: "",
          normal: "",
        },
        heroine: {
          result: "",
          summary: "",
          normal: "",
        },
        marijuana: {
          result: "",
          summary: "",
          normal: "",
        },
        morphine: {
          result: "",
          summary: "",
          normal: "",
        },
        bloodalcohol: {
          result: "",
          summary: "",
          normal: "",
        },
      },
    };
  },
  created() {
    this.detailAll();
  },
  methods: {
    detailAll() {
      EventBus.$on("detailAll_GetOneForm", async (item) => {
        if (item !== undefined && item !== null) {
          this.BloodGroupDetection = item.labResult.bloodGroupDetection;
          this.hepatitisA = item.labResult.hepatitisA;
          this.HepatitisB = item.labResult.hepatitisB;
          this.hepatitisC = item.labResult.hepatitisC;
          this.KidneyFunction = item.labResult.kidneyFunction;
          this.LiverFunction = item.labResult.liverFunction;
          this.UricAcidFunction = item.labResult.uricAcidFunction;
          this.Urine = item.labResult.urine;
          const params = new URLSearchParams();
          params.append("id", item.patient_id);
          await this.axios
            .get(`${process.env.VUE_APP_BACKEND_URL}/v1/patients?${params}`)
            .then((res) => {
              if (res.data.data) {
                this.gender = res.data.data.gender;
                if (!this.gender) {
                  if (
                    res.data.data.account_title_th == "เด็กชาย" ||
                    res.data.data.account_title_th == "นาย"
                  ) {
                    this.gender = "ชาย";
                  } else {
                    this.gender = "หญิง";
                  }
                }
              }
            })
            .catch((err) => {
              console.log("axios get transactions err: ", err.message);
            });
        } else {
          this.clear();
        }
      });
    },
    cal_reuslt(section, data, min = 0, max = 0, operator = null) {
      let result = null;
      if ((operator === "<" || operator === ">") && section != "gfr") {
        if (operator === "<") {
          this.LiverFunction[`${section}`].summary =
            data < max ? "ปกติ" : "ผิดปกติ";
        } else if (operator === ">") {
          this.LiverFunction[`${section}`].summary =
            data > max ? "ปกติ" : "ผิดปกติ";
        }
      } else if (section == "gfr" || operator === ">") {
        this.KidneyFunction[`${section}`].summary =
          data > max ? "ปกติ" : "ผิดปกติ";
      } else if (section === "bun" || section === "creatinine") {
        if (
          data ||
          (data === "" && this.KidneyFunction[`${section}`].summary)
        ) {
          result = HealthCheckCal("LiverFunction", data, {
            min: min,
            max: max,
          });
          this.KidneyFunction[`${section}`].summary =
            this.KidneyFunction[`${section}`].result.length < 1
              ? ""
              : result.result;
        }
      } else if (
        data ||
        (data === "" && this.LiverFunction[`${section}`].summary)
      ) {
        result = HealthCheckCal("LiverFunction", data, { min: min, max: max });
        this.LiverFunction[`${section}`].summary =
          this.LiverFunction[`${section}`].result.length < 1
            ? ""
            : result.result;
      }
    },
    cal_reuslt_maxmin(section, data, max, min) {
      data = parseInt(data, 10);
      data = data.toString();
      const liverTest = [
        "totalBilirubin",
        "albumin",
        "totalProtein",
        "alkPhosphatase",
      ];
      const kidneyTest = ["bun", "creatinine"];
      if (parseFloat(data) >= min && parseFloat(data) <= max) {
        if (liverTest.includes(section)) {
          this.LiverFunction[`${section}`].summary = "ปกติ";
        } else if (kidneyTest.includes(section)) {
          this.KidneyFunction[`${section}`].summary = "ปกติ";
        }
      } else if (parseFloat(data) > max) {
        if (liverTest.includes(section)) {
          this.LiverFunction[`${section}`].summary = "สูงกว่าปกติ";
        } else if (kidneyTest.includes(section)) {
          this.KidneyFunction[`${section}`].summary = "สูงกว่าปกติ";
        }
      } else if (parseFloat(data) < min) {
        if (liverTest.includes(section)) {
          this.LiverFunction[`${section}`].summary = "ต่ำกว่าปกติ";
        } else if (kidneyTest.includes(section)) {
          this.KidneyFunction[`${section}`].summary = "ต่ำกว่าปกติ";
        }
      } else {
        if (liverTest.includes(section)) {
          this.LiverFunction[`${section}`].summary = "";
        } else if (kidneyTest.includes(section)) {
          this.KidneyFunction[`${section}`].summary = "";
        }
      }
    },
    cal_reuslt_max(section, data, max) {
      const liverTest = ["directBilirubin"];
      if (parseFloat(data) <= max) {
        if (liverTest.includes(section)) {
          this.LiverFunction[`${section}`].summary = "ปกติ";
        }
      } else if (parseFloat(data) > max) {
        if (liverTest.includes(section)) {
          this.LiverFunction[`${section}`].summary = "ผิดปกติ";
        }
      } else {
        if (liverTest.includes(section)) {
          this.LiverFunction[`${section}`].summary = "";
        }
      }
    },
    cal_reuslt_maxmin_gender(section, data, max_m, max_f, min_m, min_f) {
      if (this.gender == "หญิง") {
        if (parseFloat(data) >= min_f && parseFloat(data) <= max_f) {
          this.LiverFunction[`${section}`].summary = "ปกติ";
        } else if (parseFloat(data) > max_f) {
          this.LiverFunction[`${section}`].summary = "สูงกว่าปกติ";
        } else if (parseFloat(data) < min_f) {
          this.LiverFunction[`${section}`].summary = "ต่ำกว่าปกติ";
        } else {
          this.LiverFunction[`${section}`].summary = "";
        }
      } else {
        if (parseFloat(data) >= min_m && parseFloat(data) <= max_m) {
          this.LiverFunction[`${section}`].summary = "ปกติ";
        } else if (parseFloat(data) > max_m) {
          this.LiverFunction[`${section}`].summary = "สูงกว่าปกติ";
        } else if (parseFloat(data) < min_m) {
          this.LiverFunction[`${section}`].summary = "ต่ำกว่าปกติ";
        } else {
          this.LiverFunction[`${section}`].summary = "";
        }
      }
    },
    cal_reuslt_max_gender(section, data, max_m, max_f) {
      if (!data) {
        this.LiverFunction[`${section}`].summary = "";
      } else {
        if (this.gender == "หญิง") {
          if (data <= max_f) {
            this.LiverFunction[`${section}`].summary = "ปกติ";
          } else if (data > max_f) {
            this.LiverFunction[`${section}`].summary = "ผิดปกติ";
          } else {
            this.LiverFunction[`${section}`].summary = "";
          }
        } else {
          if (data <= max_m) {
            this.LiverFunction[`${section}`].summary = "ปกติ";
          } else if (data > max_m) {
            this.LiverFunction[`${section}`].summary = "ผิดปกติ";
          } else {
            this.LiverFunction[`${section}`].summary = "";
          }
        }
      }
    },
    calgender_reuslt(
      section,
      data,
      // min = {},
      // max = {},
      // operator = null,
      // gender = null
    ) {
      if (data) {
        if (this.itemGender == "ชาย") {
          this.UricAcidFunction[`${section}`].summary =
            data >= 3.5 && data <= 7.2 ? "ปกติ" : "ผิดปกติ";
        } else {
          this.UricAcidFunction[`${section}`].summary =
            data >= 2.6 && data <= 6.0 ? "ปกติ" : "ผิดปกติ";
        }
      } else {
        this.UricAcidFunction[`${section}`].summary = "";
      }
      // if ((operator === "<" || operator === ">") && data) {
      //   if (operator === "<") {
      //     if (gender == "ชาย") {
      //       this.UricAcidFunction[`${section}`].summary =
      //         data < max.M ? "ปกติ" : "ผิดปกติ";
      //     } else {
      //       this.UricAcidFunction[`${section}`].summary =
      //         data < max.F ? "ปกติ" : "ผิดปกติ";
      //     }
      //   }
      // } else if (!data) {
      //   this.UricAcidFunction[`${section}`].summary = "";
      // }
    },
    clear() {
      this.BloodGroupDetection.bloodGroup.result = "";
      this.BloodGroupDetection.bloodGroup.summary = "";
      this.BloodGroupDetection.bloodGroup.normal = "";
      this.BloodGroupDetection.bloodGroup_RH.result = "";
      // this.BloodGroupDetection.bloodGroup_RH.summary = "";
      // this.BloodGroupDetection.bloodGroup_RH.normal = "";
      // ----------------------
      this.HepatitisB.HBsAg.result = "";
      this.HepatitisB.HBsAg.summary = "";
      this.HepatitisB.HBsAg.normal = "";
      this.HepatitisB.antiHBs.result = "";
      this.HepatitisB.antiHBs.summary = "";
      this.HepatitisB.antiHBs.normal = "";
      // ----------------------
      this.KidneyFunction.bun.result = "";
      this.KidneyFunction.bun.summary = "";
      this.KidneyFunction.creatinine.result = "";
      this.KidneyFunction.creatinine.summary = "";
      // this.KidneyFunction.gfr.result = "";
      // this.KidneyFunction.gfr.summary = "";
      // ----------------------
      this.LiverFunction.totalProtein.result = "";
      this.LiverFunction.totalProtein.summary = "";
      this.LiverFunction.albumin.result = "";
      this.LiverFunction.albumin.summary = "";
      this.LiverFunction.glubulin.result = "";
      this.LiverFunction.glubulin.summary = "";
      this.LiverFunction.totalBilirubin.result = "";
      this.LiverFunction.totalBilirubin.summary = "";
      this.LiverFunction.directBilirubin.result = "";
      this.LiverFunction.directBilirubin.summary = "";
      // this.LiverFunction.indirectBilirubin.result = "";
      // this.LiverFunction.indirectBilirubin.summary = "";
      this.LiverFunction.sgot.result = "";
      this.LiverFunction.sgot.summary = "";
      this.LiverFunction.sgpt.result = "";
      this.LiverFunction.sgpt.summary = "";
      this.LiverFunction.alkPhosphatase.result = "";
      this.LiverFunction.alkPhosphatase.summary = "";
      // ----------------------
      this.UricAcidFunction.uricAcid.result = "";
      this.UricAcidFunction.uricAcid.summary = "";
      // ----------------------
      this.Urine.amphetamine.result = "";
      this.Urine.amphetamine.summary = "";
      this.Urine.amphetamine.normal = "";
      // this.Urine.heroine.result = "";
      // this.Urine.heroine.summary = "";
      // this.Urine.heroine.normal = "";
      // this.Urine.marijuana.result = "";
      // this.Urine.marijuana.summary = "";
      // this.Urine.marijuana.normal = "";
      // this.Urine.morphine.result = "";
      // this.Urine.morphine.summary = "";
      // this.Urine.morphine.normal = "";
      // this.Urine.bloodalcohol.result = "";
      // this.Urine.bloodalcohol.summary = "";
      // this.Urine.bloodalcohol.normal = "";
    },
    toggleExpand1() {
      this.toggle1 = !this.toggle1;
    },
    toggleExpand2() {
      this.toggle2 = !this.toggle2;
    },
    toggleExpand3() {
      this.toggle3 = !this.toggle3;
    },
    toggleExpand4() {
      this.toggle4 = !this.toggle4;
    },
    toggleExpand5() {
      this.toggle5 = !this.toggle5;
    },
    toggleExpand6() {
      this.toggle6 = !this.toggle6;
    },
    validateNumber: (event) => {
      const keyCode = event.keyCode;
      const input = event.target;
      const value = input._value;
      if (keyCode < 46 || keyCode > 57 || keyCode == 47) {
        event.preventDefault();
      }
      if (event.key === "." && value.includes(".")) {
        event.preventDefault();
        return;
      }

      if (event.key === "0" && value == "") {
        input.value = "0";
        event.preventDefault();
        return;
      }
      setTimeout(() => {
        if (/^0\d/.test(input.value)) {
          input.value = input.value.replace(/^0+/, "");
        }
      }, 0);
    },
  },
  beforeDestroy() {
    EventBus.$off("detailAll_GetOneForm", this.detailPhysicalExam);
  },
};
</script>

<style scoped>
.my-table thead th {
  background: #00a99d !important;
  color: #ffffff !important;
}
::v-deep .v-data-table-header th {
  font-size: 15px !important;
  font-weight: 500 !important;
}
::v-deep .v-data-table-header th:first-child {
  border-top-left-radius: 16px;
}
::v-deep .v-data-table-header th:last-child {
  border-top-right-radius: 16px;
}
.custom-text-field {
  font-size: 14px !important;
  background-color: white !important;
}

/* สำหรับ Chrome, Edge และเบราว์เซอร์ที่ใช้ WebKit */
::v-deep input[type="number"]::-webkit-inner-spin-button,
::v-deep input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* สำหรับ Firefox */
::v-deep input[type="number"] {
  -moz-appearance: textfield;
}
</style>
